import { Component } from 'react';
import {actions, Control, Errors} from 'forms/rrf';
import { Button, FormGroup, FormLabel, OverlayTrigger, Tooltip } from 'react-bootstrap';
import PropTypes from 'prop-types';
import {validators} from '../../../../utils/validators';
import PasswordMaskInput from './password-mask-input';

class RequiredPasswordMaskInput extends Component {
  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };
  changeAction = (model, value) => (dispatch) => {
    dispatch(actions.change(model, value));
    dispatch(actions.resetValidity(model));
    if (typeof this.props.onChange === 'function') {
      this.props.onChange(value);
    }
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      model, label, controlId, errorLabel, tooltip, debounce, ...props
    } = this.props;

    return (
      <FormGroup controlId={controlId} className={`form-group${this.state[errorLabel] ? ` has-${this.state[errorLabel]}` : ''}`}>
        {label && (
          <FormLabel>
            {label}
            *
          </FormLabel>
        )}
        {
          tooltip && (
            <OverlayTrigger
              overlay={(
                <Tooltip className="tooltip" id="tooltip">
                  {tooltip}
                </Tooltip>
              )}
              placement="left"
            >
              <Button variant="default" className="tip float-end" tabIndex="-1">
                ?
              </Button>
            </OverlayTrigger>
          )
        }

        <div style={{position: 'relative'}}>
          <Control
            changeAction={this.changeAction}
            component={PasswordMaskInput}
            debounce={debounce || 0}
            model={model}
            type="password"
            validators={{required: validators.required(this.updateErrors, errorLabel)}}
            {...props}
          />
        </div>

        <Errors
          className="errors"
          messages={{
            required: 'This field is required',
            patternMismatch: 'Value does not match the required pattern'
          }}
          model={model}
          show={{
            touched: true,
            focus: false
          }}
        />
      </FormGroup>
    );
  }
}

RequiredPasswordMaskInput.propTypes = {
  model: PropTypes.string.isRequired,
  label: PropTypes.string,
  pattern: PropTypes.string,
  controlId: PropTypes.string,
  placeholder: PropTypes.string,
  errorLabel: PropTypes.string,
  tooltip: PropTypes.string,
  debounce: PropTypes.number
};

RequiredPasswordMaskInput.defaultProps = {
  controlId: Math.random()
    .toString(16)
    .substring(2),
  errorLabel: 'error',
};

export default RequiredPasswordMaskInput;
